import { ActionCreatorWithPayload } from '@reduxjs/toolkit';
import Skeleton from 'react-loading-skeleton';
import DropdownMultiselect from '@cas/components/inputs/dropdown-multiselect/DropdownMultiselect';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import useDropdownMultiselect from '@customer/components/inputs/dropdown-multiselect/useDropdownMultiselect';
import { useTranslation } from 'react-i18next';

interface ColumnDropdownProps<T> {
  uid: string;
  action?: ActionCreatorWithPayload<T[]>;
  callback?: (payload: T[]) => void;
  useValueHook: () => T[];
  useItemsHook: () => DropdownItemProps<T>[];
}

export const ColumnDropdown = <T,>({
  uid,
  action,
  callback,
  useValueHook,
  useItemsHook,
}: ColumnDropdownProps<T>) => {
  const { t } = useTranslation();

  const value: T[] = useValueHook();

  const { elementRef, items, onChange } = useDropdownMultiselect<T>({
    useItemsHook,
    action,
    callback,
  });

  return items.length ? (
    <DropdownMultiselect
      elementRef={elementRef}
      items={items}
      onChange={onChange}
      uid={uid}
      value={value}
      disabled={!items.length}
      displaySelectionLimit={0}
      displaySelectionLimitText={t('columns selected')}
      placeholder={t('SelectColumns')}
      showClearButton={false}
    />
  ) : (
    <Skeleton width="100%" height={34} />
  );
};

export default ColumnDropdown;
